import $ from 'jquery'
import findMatching from 'lodash/find'

let productInfo

export function init() {
  try {
    productInfo = JSON.parse($('#product-info').text())
  } catch (e) {
    return
  }

  // use timeout since going "back" restores the
  // select values after this tick
  setTimeout(update)
  $('[data-product-option]').change(update)
}

function update() {
  const selectedOptions = productInfo.product.override_attributes.reduce((acc, attribute) => {
    acc[attribute] = $(`[data-product-option="${attribute}"]`).val()
    return acc
  }, {})

  const selectedOptionsPricing = productInfo.pricing.override_attributes.reduce((acc, attribute) => {
    acc[attribute] = $(`[data-product-option="${attribute}"]`).val()
    return acc
  }, {})

  const overrides = findMatching(productInfo.overrides, selectedOptions) || {}
  const overridesPricing = findMatching(productInfo.pricing.overrides, selectedOptionsPricing) || {}
  const product = { ...productInfo.product, ...overridesPricing, ...overrides }

  $('[data-product-sku]').text(product.sku)
  $('select[data-product-price] option').text(product.price)
  $('img[data-product-image]').attr('src', product.image)
}
